import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSessionId } from "../lib/auth";
import { useAuth } from "../lib/AuthContext";

/**
 * Handles the return from Emergent Google OAuth.
 * The URL contains `#session_id=xxxxx` in its fragment.
 * We exchange it once for a persistent session cookie, then navigate away.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH
 */
const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Determine where to send the user after auth
    const cleanPath = window.location.pathname || "/minha-conta";
    const target = cleanPath === "/" ? "/minha-conta" : cleanPath;

    if (!sessionId) {
      navigate(target, { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await exchangeSessionId(sessionId);
        setUser(user);
        // Strip the session_id from the URL
        window.history.replaceState({}, "", target);
        navigate(target, { replace: true, state: { user } });
      } catch (e) {
        console.error("Auth exchange failed", e);
        navigate("/login?erro=1", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-[#0E2452] text-white">
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-2 border-[#FF5A00] border-t-transparent rounded-full animate-spin" />
        <p className="text-sm font-body text-white/70">A confirmar a sua sessão...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
